/**
 * 거래 API 헬퍼 함수들
 * Context를 통해 Demo/Real API를 자동으로 선택합니다
 */

import { useApiClient } from '@/app/contexts/DemoTradeContext';
import { useToken } from '../auth/token';
import { useCallback } from 'react';

/**
 * 주문 생성/취소/수정을 위한 API Hook
 * Demo 모드에서는 자동으로 DemoAPI 사용, Real 모드에서는 API 사용
 */
export function useTradeApi() {
  const { api } = useApiClient();
  const { data: token } = useToken();

  /**
   * 주문 생성 (POST /trade/order)
   * Demo: POST /orders?type=DEMO
   * Real: POST /trade/order
   */
  const createOrder = useCallback(
    async (orderParams: any) => {
      return await api.post('/trade/order', '' + token, orderParams);
    },
    [api, token]
  );

  /**
   * 주문 취소 (POST /trade/cancel)
   * Demo: POST /trade/cancel?type=DEMO
   * Real: POST /trade/cancel
   */
  const cancelOrder = useCallback(
    async (cancelParams: { orderid: number; is_triggered?: boolean }) => {
      return await api.post('/trade/cancel', '' + token, cancelParams);
    },
    [api, token]
  );

  /**
   * 주문 취소 (로그아웃 안 함)
   * 여러 주문 취소 시 사용 (race condition 방지)
   */
  const cancelOrderNoLogout = useCallback(
    async (cancelParams: { orderid: number; is_triggered?: boolean }) => {
      return await api.postNoLogout('/trade/cancel', '' + token, cancelParams);
    },
    [api, token]
  );

  /**
   * 주문 수정 (PUT /trade/order)
   * Demo: PUT /trade/order?type=DEMO
   * Real: PUT /trade/order
   */
  const updateOrder = useCallback(
    async (updateParams: { order_id: number; price: number }) => {
      return await api.put('/trade/order', '' + token, updateParams);
    },
    [api, token]
  );

  return {
    createOrder,
    cancelOrder,
    cancelOrderNoLogout,
    updateOrder,
    token,
  };
}
